import React, { useEffect } from "react";
import "../Home/Home.css";
import { motion as m } from "framer-motion";
import { IoIosArrowForward } from "react-icons/io";
import { Blogs_data } from "../../Config";

const Blogs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: [0, 0.5, 1] }}
      transition={{ duration: 0.9, ease: "easeIn" }}
      style={{ willChange: "opacity" }}
    >
      <div className="bg-white dark:bg-black dark:text-white transition-all duration-300 ease-in-out">
        {/* Banner */}
        <div className="px-5 lg:px-[7%] 2xl:px-[13%] py-10 pt-32">
          <div className="card_titleBanner relative w-full pt-14 pb-12 group rounded-lg overflow-hidden flex flex-col bg-gray-100 text-gray-900 dark:bg-neutral-800 border border-gray-100 dark:border-gray-800 text-left p-3 dark:text-gray-50 text-base font-bold transition-all duration-300 ease-in-out">
            <div className="flex flex-col sm:items-center">
              <p className="font-semibold uppercase text-3xl lg:text-4xl transition-all duration-200 ease-in-out">
                Blogs
                <div className="flex h-0.5 w-10 mt-0.5 bg-teal-600 rounded-full" />
              </p>

              <p className="flex items-center gap-1 mt-3 text-sm">
                Home <IoIosArrowForward className="text-teal-600" />
                <i>Blogs</i>
              </p>
            </div>
          </div>
        </div>

        {/* Blogs grid */}
        <div className="px-5 lg:px-[10%] 2xl:px-[15%] py-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-x-8 gap-y-16">
            {Blogs_data.map((blog, index) => (
              <a
                key={index}
                href={blog.href}
                className="group bg-white dark:bg-[#252525] py-2 px-3 shadow-md hover:shadow-custom dark:hover:shadow-white rounded-lg flex flex-col transition-all duration-300 ease-in-out"
              >
                <img
                  src={blog.imgSrc}
                  alt="Blog-Img"
                  className="w-full aspect-[5/4] object-center object-cover rounded-t-md shadow-custom -mt-8 group-hover:-translate-y-2 transition-all duration-300 ease-in-out"
                  loading="lazy"
                />

                <div className="p-1 mt-3">
                  <p className="font-medium text-base 2xl:text-lg">
                    {blog.title}
                  </p>

                  <p className="text-sm 2xl:text-xl mt-6">{blog.author}</p>
                  <p className="text-[12px] 2xl:text-lg font-light mt-1">
                    {`${blog.date} ∙ ${blog.readTime}`}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </m.div>
  );
};

export default Blogs;
